window.casino = window.casino || {};
var repos = window.casino.repos = window.casino.repos || {};


repos.pobjedniciDanaRepo = function () {
    var url = 'api/pobjednicidana';

  
    var list = function () {

        return fetch(url)
            .then(casino.repos.base.checkResponse)
            .then(function (response) {
                return response.json();
            })
            .catch(casino.repos.base.handleNetworkException);

    };

    return {
        list: list
    }

}();